import { TextTemplateComponent } from '../../test/text-template/text-template.component';
import { FlashCallAccess } from '../models/flash-call.model';
import { CreateTestGroup } from './live-number-testing.service';

export class FlashCallFormUtils {
  static readonly TEST_ID_TYPE = 'NUMERIC';
  static readonly UNAVAILABLE_MESSAGE = 'Flash call detection is no longer available for your account.';

  static applyFlashCallSettings(model: CreateTestGroup, access: FlashCallAccess): CreateTestGroup {
    return {
      ...model,
      contentTexts: model.contentTexts.map(text => ({
        ...text,
        telqIdType: FlashCallFormUtils.TEST_ID_TYPE,
      })),
      ttl: access.ttlSeconds,
      useRcsNumbers: false,
      flashCallDetection: true,
    };
  }

  static getValidationError(model: CreateTestGroup): string | null {
    if (model.contentTexts.some(text => !FlashCallFormUtils.hasTestIdPlaceholder(text.text))) {
      return 'Every text must contain the Test ID Text when flash call detection is enabled.';
    }
    return null;
  }

  static hasTestIdPlaceholder(text: string): boolean {
    return !!text && text.includes(TextTemplateComponent.PLACEHOLDER_MARKER);
  }

  static ttlOverrideMessage(ttlSeconds: number, ttlMin: number): string {
    const flashCallTtl = FlashCallFormUtils.formatTtl(ttlSeconds);
    if (flashCallTtl && Number(ttlMin) * 60 === ttlSeconds) {
      return `Flash call detection uses a fixed TTL of ${flashCallTtl}.`;
    }
    const needs = flashCallTtl ? `needs a TTL of ${flashCallTtl}` : 'needs its own fixed TTL';
    const replacedTtl = ttlMin > 0 ? `your TTL of ${ttlMin} min` : 'the TTL you set';
    return `Flash call detection ${needs}, so it replaces ${replacedTtl} for these tests.`;
  }

  static formatTtl(ttlSeconds: number): string {
    if (!ttlSeconds) {
      return '';
    }
    return ttlSeconds % 60 === 0 ? `${ttlSeconds / 60} min` : `${ttlSeconds} sec`;
  }
}
